export interface MoneyTotal {
  display: { currency: string; total: string } | null;
  by_currency: Array<{ currency: string; total: string }>;
}

export interface OrganizationDashboard {
  scope: 'organization' | 'mine';
  period: { key: string; from: string; to: string };
  display_currency: string;
  leads?: { created: number; converted_in_period: number; conversion_rate: number | null; by_status: Record<string, number> };
  lead_trend?: Array<{ month: string; label: string; leads: number; conversions: number }>;
  deals?: { open_count: number; won_count: number; lost_count: number; win_rate: number | null; won_value: MoneyTotal; closing_soon: Array<{ id: string; title: string; amount: string; currency: string; expected_close_date: string; account?: { name: string } | null; stage?: { name: string } | null }> };
  pipeline?: { pipeline: { id: string; name: string }; open_value: MoneyTotal; stages: Array<{ stage: { id: string; name: string; color: string }; count: number; value: MoneyTotal }> } | null;
  projects?: { total: number; active: number; completed: number };
  tasks?: { open: number; overdue: number; due_today: number; completed_in_period: number };
  activities?: { upcoming: Array<{ id: string; title: string; type: string; starts_at: string }> };
  invoices?: { outstanding: MoneyTotal; overdue: MoneyTotal & { count: number }; collected: MoneyTotal; issued_in_period: number };
  revenue_by_month?: Array<MoneyTotal & { month: string; label: string }>;
  contracts?: { active: number; expiring_30_days: number; expiring: Array<{ id: string; number: string; title: string; account: string | null; end_date: string }> };
  quotes?: { awaiting_approval: number; awaiting_customer: number; accepted_in_period: number };
  expenses?: { base_currency: string; pending_approval_count: number; awaiting_reimbursement: string };
}

export function moneyLabel(money: MoneyTotal): string {
  if (money.display) return `${money.display.currency} ${Number(money.display.total).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
  return money.by_currency.map(({ currency, total }) => `${currency} ${Number(total).toLocaleString(undefined, { maximumFractionDigits: 2 })}`).join(' · ') || '—';
}
